import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

export const dateToString = (date: Date) => moment(date).format(DATE_FORMAT);

export const stringToDate = (date: string) => moment(date, DATE_FORMAT).toDate();

export const SINCE_INCEPTION_LABEL = 'Since Inception';
